import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { AlertService } from './services/alert.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  
  @ViewChild('reserveSuccess', { static: false }) private reserveSuccess: SwalComponent;
  @ViewChild('reserveError', { static: false }) private reserveError: SwalComponent;

  constructor(
    protected alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.alertService.setComponent(this);
  }

  showError(title: string, text: string) {
    this.reserveError.title = title;
    this.reserveError.text = text;
    this.reserveError.fire();
  }

  showSuccess(title: string, text: string) {
    this.reserveSuccess.title = title;
    this.reserveSuccess.text = text;
    this.reserveSuccess.fire();
  }
}
